import {useState} from 'react';
import {Card, Divider, Tab, Tabs} from '@mui/material';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import AccountsTab from './AccountsTab';
import RolesTab from './RolesTab';

// Settings > Account Management. Two tabs:
// - Accounts: staff accounts, their role and status (existing feature).
// - Roles: roles are dynamic DB records a superAdmin/admin can create,
//   rename and set module permissions on (see src/models/role.model.js on
//   the backend) — SuperAdmin/Admin themselves are fixed "system roles" and
//   can't be edited or deleted from here.
// Departments are NOT managed here — they're a fixed, hardcoded list (see
// moduleConfig.js) used only by the legacy department field on an account,
// unrelated to module-access/roles. There is no backend CRUD for them.
const AccountManagement = () => {
  const [tab, setTab] = useState(0);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={3} pb={3}>
        <Card>
          <MDBox p={3} pb={0}>
            <MDTypography variant="h5" fontWeight="medium">
              Account Management
            </MDTypography>
            <MDTypography variant="button" color="text">
              Manage staff accounts and roles. A role decides which sections of the admin panel
              an account can see.
            </MDTypography>
          </MDBox>

          <MDBox px={3} pt={2}>
            <Tabs value={tab} onChange={(_, value) => setTab(value)}>
              <Tab label="Accounts" />
              <Tab label="Roles" />
            </Tabs>
          </MDBox>
          <Divider sx={{my: 0}} />

          {tab === 0 && <AccountsTab />}
          {tab === 1 && <RolesTab />}
        </Card>
      </MDBox>
    </DashboardLayout>
  );
};

export default AccountManagement;
